import copyToClipboard from 'copy-to-clipboard';
import { useState, useEffect } from 'react';

export const useClipboard = (timeout = 4000) => {
  const [copied, setCopied] = useState(false);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (copied) {
      const copiedTimeout = setTimeout(() => {
        setCopied(false);
      }, timeout);

      return () => {
        clearTimeout(copiedTimeout);
      };
    }
  }, [copied, timeout]);

  const copy = (text: string) => {
    const result = copyToClipboard(text, {
      format: 'text/plain',
    });

    if (result) {
      setCopied(true);
    }

    return result;
  };

  return [copied, copy] as const;
};
